import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showProductLoader,
    onSaveProduct,
    onProductClose,
} from 'actions/product';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const ProductEdit = () => {
    const dispatch = useDispatch();
    const editProductState = useSelector(state => state.products.editProductState);
    const product = useSelector(state => state.products.selectedProduct);
    const allValueStreams = useSelector(state => state.valueStreams.allValueStream);
    const allMembers = useSelector(state => state.members.allMember);
    const allBusinessUnits = useSelector(state => state.businessUnits.allBusinessUnit);
    const [selectedProduct, setSelectedProduct] = useState(product);
    const [formErrors, setFormErrors] = useState({ name: '' });
    const [formValid, setFormValid] = useState(false);

    // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes
    useEffect(() => {
        setSelectedProduct(product);
        setFormValid(false);
        validateForm();
    }, [product]);

    // using selectedProduct makes it behave like componentDidUpdate - effect takes place when selectedProduct changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedProduct]);

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedProductField(name, value);
        validateField(name, value);
    };

    const updateSelectedProductField = (fieldName, value) => {
        const newProduct = { ...selectedProduct };
        newProduct[fieldName] = value;
        setSelectedProduct(newProduct);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedProduct));
    };


    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showProductLoader());
                dispatch(onProductClose());
                dispatch(onSaveProduct(selectedProduct));
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onProductClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedProduct)}
                        {showErrors(formErrors)}
                        {inputFields(selectedProduct, allValueStreams, allBusinessUnits, allMembers, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };
    
    return (
        <Modal className="modal-box" isOpen={editProductState}>
            {modalHeader(<IntlMessages id="product.saveProduct" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="product.saveProduct" />)}
        </Modal>
    );
};

export default ProductEdit;


// WEBPACK FOOTER //
// ./components/Agile/product/productMaintenance/productEdit/index.js